import CategoryTag from "@/domain/enums/CategoryTag";
import TodoItem from "../TodoItem";
import EmailEntity from "./EmailEntity";

type EmailAIDetailsProps = {
    mailSummary: string;
    longMailSummary: string;
    categories: CategoryTag[];
    entities: EmailEntity[];
    analyzedMailDate: Date;
    keywords: string[];
    toDo: TodoItem[];
};

export default class EmailAIDetails {
    mailSummary: string;

    longMailSummary: string;

    categories: CategoryTag[];

    entities: EmailEntity[];

    analyzedMailDate: Date;

    keywords: string[];

    toDo: TodoItem[];

    constructor({
        mailSummary,
        longMailSummary,
        categories,
        entities,
        analyzedMailDate,
        keywords,
        toDo,
    }: EmailAIDetailsProps) {
        this.mailSummary = mailSummary;
        this.longMailSummary = longMailSummary;
        this.categories = categories;
        this.entities = entities;
        this.analyzedMailDate = analyzedMailDate;
        this.keywords = keywords;
        this.toDo = toDo;
    }
}
